import { getEnvDateFormat } from '@common/utils'
import { MolsonDatePicker } from '@components/reusable'
import type { Dayjs } from 'dayjs'
import type React from 'react'
import type { Dispatch, SetStateAction } from 'react'

export interface MolsonDatePickerWrapperProps {
  /** Custom format override - if not provided, will use getEnvDateFormat() */
  format?: string
  /** All other props passed through to MolsonDatePicker */
  sx?: React.CSSProperties | object
  disablePast?: boolean
  disabled?: boolean
  label?: string | boolean
  'data-testid'?: string
  onChange?: (date: Dayjs | null) => void
  setValue?: Dispatch<SetStateAction<Dayjs>>
  value?: Dayjs | null
  minDate?: Dayjs
  maxDate?: Dayjs
  readOnly?: boolean
}

/**
 * Wrapper around MolsonDatePicker that automatically applies the environment-specific
 * date format using getEnvDateFormat(). Supports all MolsonDatePicker props and allows
 * custom format override when needed.
 */
export const MolsonDatePickerWrapper = ({
  format,
  value,
  setValue,
  ...props
}: MolsonDatePickerWrapperProps) => {
  const dateFormat = format ?? getEnvDateFormat()
  return (
    <MolsonDatePicker
      format={dateFormat}
      value={value ?? null}
      setValue={setValue ?? (() => {})}
      {...props}
    />
  )
}
